import { Edit } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import { Column, AbTestVariant } from "src/api/types";
import { theme } from "src/assets/theme";

export const useColumns = (): Column<AbTestVariant>[] => {
  const handleEditExperiment = useCallback(() => {}, []);

  return useMemo(
    () => [
      {
        id: "edit",
        label: "Edit",
        minWidth: 80,
        align: "center",
        orderable: false,
        format: (row) => row.id.toString(),
        render: () => (
          <IconButton onClick={handleEditExperiment}>
            <Edit sx={{ color: theme.palette.secondary.main }} />
          </IconButton>
        ),
      },
      {
        id: "id",
        label: "ID",
        minWidth: 100,
        align: "center",
        orderable: false,
        format: (row) => row.id.toString(),
        render: (row) => <Typography>{row.id}</Typography>,
      },
      {
        id: "name",
        label: "Name",
        minWidth: 70,
        align: "center",
        orderable: false,
        format: (row) => row.name,
        render: (row) => <Typography>{row.name}</Typography>,
      },
      {
        id: "description",
        label: "Description",
        minWidth: 100,
        align: "center",
        orderable: false,
        format: (row) => row.description ?? "N/A",
        render: (row) => <Typography>{row.description ?? "N/A"}</Typography>,
      },
    ],
    [handleEditExperiment],
  );
};
